import { format, isSameDay, isSameMonth, isToday, parseISO } from "date-fns"
import TeacherCalendarLargeEventChip from "./TeacherCalendarLargeEventChip"

function classNames(...classes) {return classes.filter(Boolean).join(' ')}

const TeacherCalendarMonthViewLarge = ({calendarDaysWithEvents, firstDayOfCurrentMonth, setTeacherCalendarView, changeWeek, selectedDay, changeSelectedDay, setOpenEvent}) => {
  
    const jumpToDayView = (day) => {
        setTeacherCalendarView('day')
        changeWeek(day, 'jump')
        changeSelectedDay(day)
      }

    const returnTimezoneSafeDate = (day) => {
      const [year, month, date] = day.split('-').map(Number);
      const newDate = new Date(year, month - 1, date);
      return newDate
    }

    const fixTheDate = (day) => {
        const [year, month, date] = day.split('-').map(Number);
        return new Date(year, month - 1, date);
    }

    return (
        <div className="hidden w-full h-5/6 lg:grid lg:grid-cols-7 lg:grid-rows-6 lg:gap-px">
          {Object.keys(calendarDaysWithEvents).map((day, index) => (
            <div key={index} className={classNames(isSameMonth(returnTimezoneSafeDate(day), firstDayOfCurrentMonth) ? 'bg-white text-gray-600' : 'bg-blue-50 text-gray-300', 'relative py-1 px-1')}>
              <time dateTime={day.date} onClick={() => jumpToDayView(day)} className={classNames(isToday(fixTheDate(day)) ? 'flex-auto h-5 w-4 p-1 px-1.5 items-center text-center justify-center inline-block font-extrabold rounded-full text-sm bg-purple-600 text-white' : 'hover:bg-gray-300 rounded-full p-1 px-1.5 inline-block w-5 text-center text-sm font-extrabold cursor-pointer', (isSameDay(selectedDay.date, new Date(day)) && !isToday(new Date(day))) && 'text-indigo-600')}>
                {format(fixTheDate(day), 'd')}
              </time>
              {calendarDaysWithEvents[day].events.length > 0 && (
                <ol className="mt-2">
                  {calendarDaysWithEvents[day].events.slice(0, 2).map((event) => <TeacherCalendarLargeEventChip key={event.id} event={event} setOpenEvent={setOpenEvent} />)}
                  {calendarDaysWithEvents[day].events.length > 2 && <li onClick={() => jumpToDayView(day)} className="text-gray-500 text-xs list-none cursor-pointer">+ {calendarDaysWithEvents[day].events.length - 2} more</li>}
                </ol>
              )}
            </div>
          ))}
        </div>
    )
}
export default TeacherCalendarMonthViewLarge;